module.exports = __webpack_public_path__ + "img/14.23e517c1.jpg";